module.exports = __webpack_public_path__ + "static/media/contextualMenu.3ac89ab2.svg";